'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddPage$() {
}
export { $c_Lpresto_Freemium2FAAddPage$ as $c_Lpresto_Freemium2FAAddPage$ };
$p = $c_Lpresto_Freemium2FAAddPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddPage$;
/** @constructor */
function $h_Lpresto_Freemium2FAAddPage$() {
}
export { $h_Lpresto_Freemium2FAAddPage$ as $h_Lpresto_Freemium2FAAddPage$ };
$h_Lpresto_Freemium2FAAddPage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-966860957);
});
$p.l = (function() {
  return "Freemium2FAAddPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Freemium2FAAddPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().Yq);
});
var $d_Lpresto_Freemium2FAAddPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddPage$, "presto.Freemium2FAAddPage$", ({
  IF: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_Freemium2FAAddPage$ as $d_Lpresto_Freemium2FAAddPage$ };
var $n_Lpresto_Freemium2FAAddPage$;
function $m_Lpresto_Freemium2FAAddPage$() {
  if ((!$n_Lpresto_Freemium2FAAddPage$)) {
    $n_Lpresto_Freemium2FAAddPage$ = new $c_Lpresto_Freemium2FAAddPage$();
  }
  return $n_Lpresto_Freemium2FAAddPage$;
}
export { $m_Lpresto_Freemium2FAAddPage$ as $m_Lpresto_Freemium2FAAddPage$ };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-Page$.js.map
